import { SWRConfiguration } from "swr";

import { FetcherResult } from "../api-client/fetcher";
import { ModifiedSWRResponse, useSwrGet } from "../api-client/useSwrGet";
import { useTireSeason } from "../blocks/Tires/Results/Filters/TireSeasonFilters/useTireSeason";
import { DealerChassisResultsRoute } from "../navigation/DealerRoutes";
import { useRouteParams } from "../navigation/useRouteParams";
import { useNullableDealerAccountInfo } from "../stores/hooks/useNullableDealerAccountInfo";
import { useGetVehicleInfo } from "./useGetVehicleInfo";
import { TireSearchResultsPayload } from "./useSearchTiresByVehicle";

export const useSearchTiresByVehicleChassis = (
  swrOptions: SWRConfiguration<FetcherResult<TireSearchResultsPayload>> = {}
): ModifiedSWRResponse<
  FetcherResult<TireSearchResultsPayload>,
  TireSearchResultsPayload
> => {
  const route = useRouteParams(DealerChassisResultsRoute);
  const dealer = useNullableDealerAccountInfo();
  const { data: vehicleInfo } = useGetVehicleInfo();
  const [season] = useTireSeason();

  const { data, ...result } = useSwrGet<TireSearchResultsPayload>(
    route && vehicleInfo
      ? "/retailSiteWebService/parts/tire/searchTiresByVehicleChassis.php"
      : null,
    {
      dealerId: route?.dealerId ?? "",
      originalEquipmentFilter: dealer?.dealerProductFilters
        .originalEquipmentFilter
        ? "OE"
        : "ALL",
      searchFailoverMethod: "SEASON",
      season: String(season),
      vehicleChassis: route?.vehicleChassis ?? "",
      vehicleSubmodelTireSizeId:
        vehicleInfo?.vehicleOriginalTiresize?.vehicleSubmodelTiresizeId ?? "",
    },
    swrOptions
  );

  return { ...result, data };
};
